import { BaseApi } from "../base.js";
import { API } from "../constants.js";
import router from "@/router";
import { reloadBalances } from "@/api/coinService";

export class WithdrawApi extends BaseApi {
  getFee(body) {
    return this.request(
      () => this.r.post(`${API.ENDPOINT}/coin/withdrawal_fee`, body),
      (d) => this.withdraw.setFee(d),
    );
  }

  validate(body) {
    return this.r.post(`${API.EMCD_API4}/wallets/validate_withdraw`, body);
  }

  async submit(code) {
    this.r.set2Fa(this.submit.bind(this));
    const { form, currentFee } = this.withdraw;
    const headers = code
      ? { "Secret-Key": this.user.secret, "Secret-Value": code }
      : {};
    const res = await this.request(
      () =>
        this.r.post(
          `${API.EMCD_API4}/wallets/withdraw`,
          {
            coin_id: form.coin.config.id,
            network_id: form.network.network_id,
            amount: Number(form.amount),
            address: form.address,
            fee: currentFee.fee,
          },
          headers,
        ),
      (d) => {
        // сохраняем payload для мгновенной ссылки, если бэк вернул payload
        if (d?.payload) this.withdraw.setInstantLinkPayload(d.payload);
        reloadBalances();
        router.push({ name: "WithdrawSuccess" });
      },
    );
    // на случай если ответ не ok и содержит payload (например, при требовании 2FA)
    if (!res?.ok && res?.payload) {
      this.withdraw.setInstantLinkPayload(res.payload);
    }
    return res;
  }
}
